import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import Row from 'blocks/Row';
import { useTranslation } from 'react-i18next';
import { PagerProps } from './pager.interface';
import * as S from './pager.styles';

const Pager = ({ total, limit = 10, page, next, prev }: PagerProps) => {
  const { t } = useTranslation();
  const pageData = {
    start: page * limit + 1,
    end: (page + 1) * limit > total ? total : (page + 1) * limit,
  };

  return (
    <S.Wrapper>
      <Row justify="flex-end">
        <S.PagerContainerText>
          {t('pager.title', { start: pageData.start, end: pageData.end, total })}
        </S.PagerContainerText>
        {total > limit && (
          <S.PagerContainerBtn as={Row}>
            {page === 0 ? (
              <S.PagerContainerBtnIcon $disable={true}>
                <ArrowCircleLeftOutlinedIcon />
              </S.PagerContainerBtnIcon>
            ) : (
              <S.PagerContainerBtnIcon onClick={prev}>
                <S.PagerContainerBtnSvg as={ArrowCircleLeftOutlinedIcon} />
              </S.PagerContainerBtnIcon>
            )}
            {(page + 1) * limit >= total ? (
              <S.PagerContainerBtnIcon>
                <S.PagerContainerBtnSvg as={ArrowCircleRightOutlinedIcon} />
              </S.PagerContainerBtnIcon>
            ) : (
              <S.PagerContainerBtnIcon onClick={next}>
                <ArrowCircleRightOutlinedIcon />
              </S.PagerContainerBtnIcon>
            )}
          </S.PagerContainerBtn>
        )}
      </Row>
    </S.Wrapper>
  );
};

export default Pager;
